import EnterpriseBrandingWrapper from './EnterpriseBrandingWrapper.component';

export default EnterpriseBrandingWrapper;
